import { Component, Input, OnInit } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

const LAYOUT = 'layout';
const layoutAttributes = ['visibleLabel', 'type', 'captureType'];

@Component({
  selector: 'app-field',
  templateUrl: './app-field.component.html',
})
export class AppFieldComponent extends FieldComponent implements OnInit {
  labelVisible: boolean;
  widgetType: string;
  labelSpan: number;
  fieldSpan: number;
  @Input() layout;

  defineLayout() {
    const layout = this.field.getCustomAttribute(LAYOUT);
    this.layout = layout ?? this.layout ?? this.formConfig.defaultFieldsLayout;
    this.labelVisible = this.field.visibleLabel
      && !this.formConfig.notLabeledFields.includes(this.field?.type)
      && !this.formConfig.notLabeledFields.includes(this.field?.captureType);
    this.labelSpan = this.formConfig.spanLayout?.[this.layout]?.label
      ?? this.formConfig.spanLayout?.default?.label ?? 8;
    this.fieldSpan = (this.labelVisible) ? (this.formConfig.spanLayout?.[this.layout]?.field
      ?? this.formConfig.spanLayout?.default?.field ?? 24) : 24;
    // this.widgetType = this.formConfig.widgets.byCapture[this.field?.captureType]
    //   ?? this.formConfig.widgets.byType[this.field?.type] ?? 'INPUT';
    this.widgetType = this.formConfig.widgets.byCapture[this.field?.captureType] ??
      this.formConfig.widgets.byType[this.field?.type] ?? 'INPUT';
  }

  override customProcessAttributeChange(attribute: string, value?: any): void {
    this.field && layoutAttributes.includes(attribute) && this.defineLayout();
  }
}
